// Pagination limits for various list views
export const PAGE_SIZE = {
  DEFAULT: 32,
  LISTINGS: 32,
  SHOWCASE: 12,
  TAG_BROWSE: 100,
  CHAT: 50,
  NOTIFICATIONS: 50,
  SELLERS: 100,
  RECOMMENDATIONS: 20,
  TAG_SHOWCASE: 5,
  AI_CHAT: 20,
} as const;

export type PageSize = (typeof PAGE_SIZE)[keyof typeof PAGE_SIZE];
